import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '@/views/HomePage.vue'
import TwoPage from '@/views/TwoPage.vue'

// import store from '@/store' // 引入 Vuex
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: HomePage
    // redirect: '/newPage'
  },
  { path: '/newPage', component: HomePage },
  { path: '/twoPage', component: TwoPage },

  //中间页面
  {
    path: '/publicPage',
    component: () => import(/* webpackChunkName: 'login' */ '@/views/publicPage')
  },

  //登录页面
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: 'login' */ '@/views/login')
  },
  // 注册完成进来的问卷的第一个页面
  {
    path: '/wenJuan/indexPage',
    name: 'WenJuanIndexPage',
    component: () => import(/* webpackChunkName: 'login' */ '@/views/wenJuan/indexPage')
  },

  //问答列表页面
  {
    path: '/wenJuan/listPage',
    name: 'WenJuanListPage',
    component: () => import(/* webpackChunkName: 'login' */ '@/views/wenJuan/listPage')
  },

  //问卷详情页面
  {
    path: '/wenJuan/detailPage',
    name: 'WenJuanDetailPage',
    component: () => import(/* webpackChunkName: 'login' */ '@/views/wenJuan/detailPage')
  },

   //问卷提交成功页面
   {
    path: '/wenJuan/tiJiaoOverPage',
    name: 'WenJuanTiJiaoOverPage',
    component: () => import(/* webpackChunkName: 'login' */ '@/views/wenJuan/tiJiaoOverPage')
  },

   //问卷分享页面
   {
    path: '/wenJuan/fenXiangPage',
    name: 'WenJuanFenXiangPage',
    component: () => import(/* webpackChunkName: 'login' */ '@/views/wenJuan/fenXiangPage')
  },


   //注册用户列表
   {
    path: '/wenJuan/userListPage',
    name: 'WenJuanUserListPage',
    component: () => import(/* webpackChunkName: 'login' */ '@/views/wenJuan/userListPage')
  },

  //年费检索-列表页面
  {
    path: '/wenJuan/nianFeiListPage',
    name: 'WenJuanNianFeiListPage',
    component: () => import(/* webpackChunkName: 'login' */ '@/views/wenJuan/nianFeiListPage')
  },

    //年费检索-列表页面
    {
      path: '/wenJuan/nianFeiDetailPage',
      name: 'WenJuanNianFeiDetailPage',
      component: () => import(/* webpackChunkName: 'login' */ '@/views/wenJuan/nianFeiDetailPage')
    },
  {
      path: '/wenJuan/listSearchRecordPage',
      name: 'listSearchRecordPage',
      component: () => import(/* webpackChunkName: 'login' */ '@/views/wenJuan/listSearchRecordPage')
    },

 

  // 注册页面
  {
    path: '/zhuCePage',
    name: 'Fegister',
    component: () => import(/* webpackChunkName: 'register' */ '@/views/zhuCePage')
  },
  // 忘记密码
  {
    path: '/findPwd',
    name: 'FindPwd',
    component: () => import(/* webpackChunkName: 'findPwd' */ '@/views/findPwd')
  },

  // 内容页面
  {
    path: '/pageInfo/indexList',
    name: 'PageInfo',
    component: () => import(/* webpackChunkName: 'PageInfo' */ '@/views/pageInfo/indexList')
  },
  
]

const router = new VueRouter({
  mode: 'hash', // 必须用 Hash 模式 （兼容微信分享）：
  routes
})

// 全局前置守卫：所有路由跳转前都会执行
// router.beforeEach((to, from, next) => {
//   // 1. 排除登录页本身（避免跳转到登录页时再次拦截，导致死循环）
//   if (to.path === '/login') {
//     next() // 直接放行
//     return
//   }

//   console.log('是否获取信息',store.state.userInfo.id)
//   // 2. 非登录页：判断是否登录，未登录则跳转登录页
//   const isLogin = !!store.state.userInfo.id // 或使用 store.getters.isLogin
//   if (!isLogin) {
//     next({
//       path: '/login',
//       query: { redirect: to.fullPath } // 携带当前路由，登录后可返回
//     })
//   } else {
//     next() // 已登录，正常放行
//   }
// })


export default router